// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1locd","signatureBlock":"Footer_signatureBlock__3lRPe","signature":"Footer_signature__ysKKt"};